import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend, type PieLabelRenderProps } from 'recharts';
import type { ModuleUsage } from '../types/analytics.types';

interface ModuleUsageChartProps {
  data: ModuleUsage | undefined;
  isLoading: boolean;
}

const COLORS = ['#B87333', '#6366f1', '#94a3b8'];

const MODULE_LABELS: Record<string, string> = {
  itc: 'ITC (CVthèque)',
  tm: 'TM (Appels d\'offres)',
  other: 'Autre',
};

export function ModuleUsageChart({ data, isLoading }: ModuleUsageChartProps) {
  const chartData = data
    ? [
        { name: MODULE_LABELS.itc, value: data.itc },
        { name: MODULE_LABELS.tm, value: data.tm },
        { name: MODULE_LABELS.other, value: data.other },
      ].filter((d) => d.value > 0)
    : [];

  const total = chartData.reduce((sum, d) => sum + d.value, 0);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Usage par module</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="h-[300px] bg-muted animate-pulse rounded" />
        ) : total === 0 ? (
          <div className="h-[300px] flex items-center justify-center text-muted-foreground">
            Aucune donnée d'utilisation
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={100}
                paddingAngle={4}
                dataKey="value"
                label={(props: PieLabelRenderProps) =>
                  `${props.name ?? ''} (${(((props.percent as number) ?? 0) * 100).toFixed(0)}%)`
                }
                labelLine={false}
                fontSize={12}
              >
                {chartData.map((_, index) => (
                  <Cell key={index} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip
                formatter={(value) => [value, 'Actions']}
                contentStyle={{
                  backgroundColor: 'hsl(var(--card))',
                  border: '1px solid hsl(var(--border))',
                  borderRadius: '8px',
                  fontSize: '12px',
                }}
              />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
